import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";

import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterLink } from "@angular/router";

import { DialogActivityComponent } from "../../../components/dialogs/dialog-activity/dialog-activity";
import { AccessRules, SuperUserRoles } from "../../../helpers/userroles";
import { AuthService } from "../../../services/authservice";
import { HealthIndicators } from "./components/health-indicators";

@Component({
  selector: "service-tile",
  templateUrl: "service-tile.html",
  styleUrls: ["service-tile.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AngularSvgIconModule,
    HealthIndicators,
    MatTooltipModule,
    NgxSkeletonLoaderModule,
    RouterLink,
    TranslatePipe,
  ],
})
export class ServiceTile {
  private dialog = inject(MatDialog);
  private auth = inject(AuthService);

  serviceUrl = input.required<string>();
  serviceIcon = input.required<string>();
  serviceTitle = input.required<string>();

  serviceMessage = input.required<any>();
  serviceMessages = input.required<any>();

  healthIndicators = input<Map<string, number>>(new Map());
  isLoading = input<boolean>();

  firewallCount = input(0);
  subscriptionCount = input.required<number>();
  serviceMessageAmount = input(0);
  actionButtonText = input("Global.SeeOverview");

  protected isCert = computed(() => this.serviceUrl() === "cert");
  protected isDomains = computed(() => this.serviceUrl() === "domains");
  protected isIpPrefix = computed(() => this.serviceUrl() === "IP_PREFIX");
  protected isIotNet = computed(() => this.serviceUrl() === "iotnet");

  private rules = AccessRules;

  public serviceRoute = computed(() => {
    if (this.isIpPrefix()) {
      return ["/ip-prefixes"];
    } else if (this.isCert()) {
      return ["/cert"];
    } else if (this.isDomains()) {
      return ["/domains", "domains-zones"];
    } else if (this.isIotNet()) {
      return ["/iotnet"];
    } else {
      return ["/diensten", this.serviceUrl()];
    }
  });

  protected hasHealthIndicators = computed(() => this.healthIndicators() !== undefined);

  // FIXME: next 3 functions are not used, but are tested in service-tile.spec.ts Basically this whole test does
  // nothing at all, except for testing in a convoluted way that for surf domeinen the test values are the same
  // as the values in a huge map ;)

  get requiredRoles() {
    const requirements = this.rules[this.serviceUrl()];
    return requirements ? requirements.view : SuperUserRoles;
  }

  get validRoles() {
    const requirements = this.rules[this.serviceUrl()];
    if (!requirements) {
      return SuperUserRoles;
    }
    return [...requirements.view, ...requirements.edit];
  }

  get hasAccess(): boolean {
    return this.auth.hasRole(this.validRoles);
  }

  openDialog(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.dialog.open(DialogActivityComponent, {
      data: this.serviceMessage(),
    });
    return false;
  }
}
